import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export const fields: any = {
  managementIntegrityMessagePageContent: drilldownData["managementIntegrityMessagePageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  managementIntegrityMessagePageHeading: drilldownData["managementIntegrityMessagePageHeading"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  antiBriberyCorruptionPageContent: drilldownData["antiBriberyCorruptionPageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  antiBriberyCorruptionPageHeading: drilldownData["antiBriberyCorruptionPageHeading"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingProgramPageContent: drilldownData["whistleblowingProgramPageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingProgramPageHeading: drilldownData["whistleblowingProgramPageHeading"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingPolicyPageContent: drilldownData["whistleblowingPolicyPageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingPolicyPageHeading: drilldownData["whistleblowingPolicyPageHeading"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  reportingConcernPageContent: drilldownData["reportingConcernPageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  reportingConcernPageHeading: drilldownData["reportingConcernPageHeading"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  managementIntegrityMessageNextPage: drilldownData["managementIntegrityMessageNextPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  antiBriberyCorruptionNextPage: drilldownData["antiBriberyCorruptionNextPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingProgramNextPage: drilldownData["whistleblowingProgramNextPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  whistleblowingPolicyNextPage: drilldownData["whistleblowingPolicyNextPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  reportingConcernNextPage: drilldownData["reportingConcernNextPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
};
